import { connect } from 'react-redux';
import _ from 'lodash';
import { getAppSettings, getSiteColors } from '../selectors/app-settings-selectors';

const getSettings = (state, config) => _.mapValues(config, (path, prop) => _.get(getAppSettings(state), path || prop));

const mapStateToProps = config => state => ({
  ...getSettings(state, config),
  siteColors: getSiteColors(state),
});

export default function withAppSettings(config) {
  return WrappedComponent => connect(mapStateToProps(config), {})(WrappedComponent);
}



// WEBPACK FOOTER //
// ./app/hoc/with-app-settings.js